var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb15",staticStyle:{"min-height":"100vh","overflow":"auto"}},_vm._l((_vm.localTree),function(item,i){return _c('div',{key:i},[_c('steps-node',{attrs:{"node":item},on:{"node:select":_vm.selectNode}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }